// Garantias de robustez em linguagem de cliente final.
// Cada projeto declara um array de chaves; o helper resolve para PT/EN.
// Mantém a copy num lugar só pra evitar duplicação entre projeto e tradução.

export type GarantiaKey =
  | "login_seguro"
  | "banco_protegido"
  | "testes_automaticos"
  | "imagens_otimizadas"
  | "mobile_first"
  | "backup_automatico"
  | "painel_proprio"
  | "pronto_google"
  | "sem_dependencia"
  | "sync_automatico"
  | "whatsapp_direto"
  | "audit"
  | "ssl_seguro"
  | "carregamento_rapido"
  | "bilingue";

export const GARANTIAS: Record<GarantiaKey, { pt: string; en: string }> = {
  login_seguro: {
    pt: "Login seguro com confirmação por e-mail",
    en: "Secure login with email confirmation",
  },
  banco_protegido: {
    pt: "Banco com regra de acesso por usuário (ninguém vê o que não é seu)",
    en: "Database with per-user access rule (nobody sees what isn't theirs)",
  },
  testes_automaticos: {
    pt: "Testes automáticos rodam antes de cada atualização do site",
    en: "Automated tests run before every site update",
  },
  imagens_otimizadas: {
    pt: "Imagens otimizadas pra carregar rápido no celular",
    en: "Images optimized to load fast on mobile",
  },
  mobile_first: {
    pt: "Funciona perfeito no celular antes de tudo",
    en: "Works perfectly on mobile, first and foremost",
  },
  backup_automatico: {
    pt: "Backup automático do banco todos os dias",
    en: "Automatic daily database backup",
  },
  painel_proprio: {
    pt: "Painel próprio: você atualiza sem precisar chamar dev",
    en: "Your own panel: update content without calling a dev",
  },
  pronto_google: {
    pt: "Cada página feita pra aparecer no Google",
    en: "Every page built to rank on Google",
  },
  sem_dependencia: {
    pt: "Continua de pé mesmo se algum serviço externo cair",
    en: "Stays up even if an external service goes down",
  },
  sync_automatico: {
    pt: "Conteúdo atualiza sozinho, sem ninguém apertar botão",
    en: "Content updates on its own, no button-pushing",
  },
  whatsapp_direto: {
    pt: "Atalho direto pro WhatsApp em toda página",
    en: "Direct WhatsApp shortcut on every page",
  },
  audit: {
    pt: "Rastro de quem fez o quê e quando, pra prestação de contas",
    en: "Trail of who did what and when, for accountability",
  },
  ssl_seguro: {
    pt: "Conexão criptografada com cadeado verde",
    en: "Encrypted connection with green padlock",
  },
  carregamento_rapido: {
    pt: "Carrega em segundos, mesmo com 4G fraco",
    en: "Loads in seconds, even on weak 4G",
  },
  bilingue: {
    pt: "Bilíngue: atende cliente em português e em inglês",
    en: "Bilingual: serves clients in Portuguese and English",
  },
};

export function formatGarantia(key: string, locale: "pt" | "en"): string {
  const g = GARANTIAS[key as GarantiaKey];
  return g ? g[locale] : key;
}
